import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import ReactDOM from "react-dom/client";
import { RecoilRoot } from "recoil";
import "./index.css";
import { RemoveTrailingSlash } from "@mirage/components/removeTrailingSlash/RemoveTrailingSlash";
import { StyledEngineProvider, ThemeProvider } from "@mui/material";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { PublicPortalRoutingService } from "./services/PublicPortalRoutingService";
import { PublicPortal } from "./app";
import { StableNavigateContextProvider } from "@mirage/hooks/useStableNavigate";
import { MirageTheme } from "@mirage/theme/MuiMirage.module";

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
const pp = new PublicPortalRoutingService();

root.render(
    <BrowserRouter basename={process.env.PUBLIC_URL}>
        <StyledEngineProvider injectFirst>
            <StableNavigateContextProvider>
                <RecoilRoot>
                    <ThemeProvider theme={MirageTheme}>
                        <DndProvider backend={HTML5Backend}>
                            <RemoveTrailingSlash />
                            <Routes>
                                <Route index element={<PublicPortal />} />
                                <Route path={`${pp.Root}/*`} element={<PublicPortal />} />
                                <Route path="*" element={<PublicPortal />} />
                            </Routes>
                        </DndProvider>
                    </ThemeProvider>
                </RecoilRoot>
            </StableNavigateContextProvider>
        </StyledEngineProvider>
    </BrowserRouter>
);

export default PublicPortal;
